module.exports = __webpack_public_path__ + "static/media/metabolism.6feaab56.svg";